import {
    INIT_MEMBER_INFO,

    GET_MEMBER_DETAIL_FAIL,
    GET_MEMBER_DETAIL_START,
    GET_MEMBER_DETAIL_SUCCESS,

    SEARCH_MEMBER_START,
    SEARCH_MEMBER_SUCCESS,
    SEARCH_MEMBER_FAIL,

    GET_MEMBER_ADDRESS_START,
    GET_MEMBER_ADDRESS_SUCCESS,
    GET_MEMBER_ADDRESS_FAIL,

    GET_MEMBER_ADDRESS_DETAIL_START,
    GET_MEMBER_ADDRESS_DETAIL_SUCCESS,
    GET_MEMBER_ADDRESS_DETAIL_FAIL,

    CART_GET_LIST_START,
    CART_GET_LIST_SUCCESS,
    CART_GET_LIST_FAIL,

    CART_EDIT_START,
    CART_EDIT_SUCCESS,
    CART_EDIT_FAIL,

    CART_REMOVE_START,
    CART_REMOVE_SUCCESS,
    CART_REMOVE_FAIL,

    CART_MULTIPLE_REMOVE_START,
    CART_MULTIPLE_REMOVE_SUCCESS,
    CART_MULTIPLE_REMOVE_FAIL,

    GET_MEMBER_PROFILE_START,
    GET_MEMBER_PROFILE_SUCCESS,
    GET_MEMBER_PROFILE_FAIL,

} from '../actions/member';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

    const { type, data, payload, error } = action;

    switch (type) {

        case GET_MEMBER_DETAIL_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case GET_MEMBER_DETAIL_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case GET_MEMBER_DETAIL_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case SEARCH_MEMBER_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case SEARCH_MEMBER_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case SEARCH_MEMBER_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case GET_MEMBER_ADDRESS_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case GET_MEMBER_ADDRESS_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case GET_MEMBER_ADDRESS_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case GET_MEMBER_ADDRESS_DETAIL_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case GET_MEMBER_ADDRESS_DETAIL_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case GET_MEMBER_ADDRESS_DETAIL_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case CART_GET_LIST_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CART_GET_LIST_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CART_GET_LIST_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case CART_EDIT_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CART_EDIT_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CART_EDIT_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================


        case CART_REMOVE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CART_REMOVE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CART_REMOVE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case CART_MULTIPLE_REMOVE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case CART_MULTIPLE_REMOVE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case CART_MULTIPLE_REMOVE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case GET_MEMBER_PROFILE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case GET_MEMBER_PROFILE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case GET_MEMBER_PROFILE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        //===================================================================================

        case INIT_MEMBER_INFO:
            {
                return initialState;
            }

        default:
            {
                return { ...state };
            }
    }
};

export default reducer;
